export const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
    >
      <path
        d="M36.5438 27.25C36.4412 27.1688 29 21.805 26.9575 22.19C25.9825 22.3625 25.425 23.0275 24.3063 24.3588C24.1263 24.5738 23.6938 25.0887 23.3575 25.455C22.6505 25.2244 21.9608 24.9437 21.2937 24.615C17.8507 22.9388 15.0687 20.1568 13.3925 16.7137C13.0636 16.0468 12.7829 15.3571 12.5525 14.65C12.92 14.3125 13.435 13.88 13.655 13.695C14.98 12.5825 15.6462 12.025 15.8188 11.0475C16.1725 9.0225 10.8125 1.53 10.7562 1.4625C10.5131 1.11509 10.1957 0.826078 9.82709 0.616379C9.4585 0.40668 9.0479 0.281535 8.625 0.25C6.4525 0.25 0.25 8.29625 0.25 9.65125C0.25 9.73 0.36375 17.735 10.235 27.7762C20.2662 37.6362 28.27 37.75 28.3488 37.75C29.705 37.75 37.75 31.5475 37.75 29.375C37.7188 28.9536 37.5944 28.5444 37.3858 28.1769C37.1772 27.8094 36.8896 27.4928 36.5438 27.25Z"
        fill="#FCA12C"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3429 24.5071C22.3477 25.1705 21.1918 25.5213 20 25.5213C18.8083 25.5213 17.6523 25.1705 16.6572 24.5071L0.266328 13.5795C0.175844 13.519 0.0870347 13.4561 0 13.3907L0 31.2967C0 33.3497 1.66602 34.979 3.68227 34.979H36.3177C38.3706 34.979 39.9999 33.313 39.9999 31.2967V13.3906C39.9127 13.4562 39.8237 13.5193 39.733 13.5798L23.3429 24.5071Z"
        fill="#FCA12C"
      />
      <path
        d="M1.56641 11.6283L17.9573 22.5559C18.5777 22.9696 19.2888 23.1764 19.9999 23.1764C20.7111 23.1764 21.4223 22.9695 22.0427 22.5559L38.4336 11.6283C39.4145 10.9748 40 9.88102 40 8.70055C40 6.67078 38.3487 5.01953 36.319 5.01953H3.68102C1.65133 5.01961 1.93758e-06 6.67086 1.93758e-06 8.7025C-0.000606547 9.28157 0.142112 9.85178 0.415428 10.3623C0.688743 10.8728 1.08416 11.3077 1.56641 11.6283Z"
        fill="#FCA12C"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="30"
      height="40"
      viewBox="0 0 30 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C11.0234 0.00529158 7.21113 1.58734 4.39924 4.39924C1.58734 7.21113 0.00529158 11.0234 0 15C0 25.7687 13.975 39.2562 14.5687 39.825C14.6842 39.9372 14.8389 40 15 40C15.161 40 15.3157 39.9372 15.4312 39.825C16.025 39.2562 30 25.7687 30 15C29.9947 11.0234 28.4126 7.21113 25.6007 4.39924C22.7888 1.58734 18.9766 0.00529158 15 0ZM15 21.875C13.6402 21.875 12.311 21.4718 11.1804 20.7163C10.0499 19.9609 9.16867 18.8872 8.64832 17.6309C8.12797 16.3747 7.99182 14.9924 8.25709 13.6587C8.52237 12.3251 9.17715 11.1001 10.1386 10.1386C11.1001 9.17715 12.3251 8.52237 13.6587 8.25709C14.9924 7.99182 16.3747 8.12797 17.6309 8.64832C18.8872 9.16867 19.9609 10.0499 20.7163 11.1804C21.4718 12.311 21.875 13.6402 21.875 15C21.8738 16.823 21.1491 18.571 19.8601 19.8601C18.571 21.1491 16.823 21.8738 15 21.875Z"
        fill="#FCA12C"
      />
    </svg>
  );
};

export const AvaliabilityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="42"
      viewBox="0 0 40 42"
      fill="none"
    >
      <path
        d="M8.69212e-05 16.3729V34.5254C8.69212e-05 38.6542 3.5472 42 7.92461 42H32.0755C36.4528 42 40 38.6543 40 34.5254V16.3729H8.69212e-05ZM29.6603 24.4169L19.0189 34.3831C18.6415 34.739 18.1887 34.8814 17.6604 34.8814C17.1321 34.8814 16.6793 34.6679 16.302 34.3831L10.2643 28.7593C9.50954 28.0475 9.50954 26.9085 10.2643 26.2678C11.019 25.5559 12.2265 25.5559 12.9058 26.2678L17.585 30.6813L26.9434 21.9966C27.3052 21.6874 27.776 21.5161 28.2642 21.5161C28.7524 21.5161 29.2232 21.6874 29.5849 21.9966C30.3396 22.5661 30.4151 23.7051 29.6603 24.4169ZM32.0754 4.98307H31.3207V1.77967C31.3207 0.78307 30.4905 0 29.434 0C28.3774 0 27.5472 0.78307 27.5472 1.77967V4.98307H12.4528V1.77967C12.4528 0.78307 11.6227 0 10.566 0C9.50945 0 8.67924 0.78307 8.67924 1.77967V4.98307H7.92453C3.5472 4.98307 0 8.3288 0 12.4577V12.8136H39.9998V12.4577C39.9999 8.3288 36.4528 4.98307 32.0754 4.98307Z"
        fill="#FCA12C"
      />
    </svg>
  );
};
